import React from 'react';
import { AdditionalFields, RequiredType } from '@rabbit/helper';
import { CommonInputBuilder } from './CommonInputBuilder';

interface DynamicFormBuilderProps {
  fields: AdditionalFields;
  userType: 'sage' | 'olive';
}

const CommonFormBuilder: React.FC<DynamicFormBuilderProps> = ({
  fields,
  userType,
}) => {
  return (
    <div className="w-full space-y-5">
      {Object.entries(fields).map(([key, field]) => (
        <CommonInputBuilder
          field={field}
          key={key}
          name={key}
          required={
            field.validation?.required === RequiredType.REQUIRED_FOR_ALL ||
            (userType === 'olive' &&
              field.validation?.required === RequiredType.REQUIRED_FOR_CONSUMER)
          }
        />
      ))}
    </div>
  );
};

export default CommonFormBuilder;
